import { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'
import type { PageContextPayload } from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import ManageAgencyOrderBundleModal from '@modals/ManageAgencyOrderBundleModal'

import { AgencyOrderBundleModel } from '@models/types'

import PageContent from './components/PageContent'

const defaultState = {
  showManageAgencyOrderBundleModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    ManageAgencyOrderBundleModal: {
      closeModal: () => setState({ showManageAgencyOrderBundleModal: false }),
      updateAgencyOrderBundle: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showManageAgencyOrderBundleModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showManageAgencyOrderBundleModal: (payload: { agency: AgencyOrderBundleModel }) => {
        setModalData('ManageAgencyOrderBundleModal', payload)
        setState({ showManageAgencyOrderBundleModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <ManageAgencyOrderBundleModal
          // @ts-expect-error TS2322
          callbacks={callbacks('ManageAgencyOrderBundleModal', setState)}
          showModal={showManageAgencyOrderBundleModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
